import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M50 79.63L22.19 95l5.31-32.56L5 39.38l31.09-4.75L50 5l13.91 29.63L95 39.38 72.5 62.44 77.81 95 50 79.63z'

const IconStarFilled: FC<IconProps> = props => (
  <SvgIcon {...props} path={PATH} />
)

export default IconStarFilled
